export default __webpack_public_path__ + "static/media/iIcon.08bf4fc9.svg";